import React from 'react'

const NotFound = () => {
  return (
    <div id="#toppage">Oops! Looks like something went wrong. Page not found</div>
  )
}

export default NotFound